export default __webpack_public_path__ + "static/media/logo verdemi.211fc171.png";